import { render, staticRenderFns } from "./goodsData.vue?vue&type=template&id=72933cc3&scoped=true&"
import script from "./goodsData.vue?vue&type=script&lang=js&"
export * from "./goodsData.vue?vue&type=script&lang=js&"
import style0 from "./goodsData.vue?vue&type=style&index=0&id=72933cc3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72933cc3",
  null
  
)

export default component.exports